// TODO: Replace with API call — GET /api/analytics/fleet-summary

export const LSD_TREND_DATA = [
  { month: 'May 25', avgLsd: 52, inspections: 4, critical: 12 },
  { month: 'Jun 25', avgLsd: 49, inspections: 5, critical: 10 },
  { month: 'Jul 25', avgLsd: 55, inspections: 3, critical: 14 },
  { month: 'Aug 25', avgLsd: 48, inspections: 6, critical: 9 },
  { month: 'Sep 25', avgLsd: 43, inspections: 7, critical: 8 },
  { month: 'Oct 25', avgLsd: 46, inspections: 5, critical: 11 },
  { month: 'Nov 25', avgLsd: 41, inspections: 8, critical: 7 },
  { month: 'Dec 25', avgLsd: 38, inspections: 9, critical: 6 },
  { month: 'Jan 26', avgLsd: 44, inspections: 7, critical: 9 },
  { month: 'Feb 26', avgLsd: 40, inspections: 8, critical: 7 },
  { month: 'Mar 26', avgLsd: 47, inspections: 6, critical: 10 },
  { month: 'Apr 26', avgLsd: 43, inspections: 5, critical: 8 },
];

export const CATEGORY_DEFICIENCY_DATA = [
  { category: 'MD', label: 'Mooring Decks', deficiencies: 47, pct: 82 },
  { category: 'ER', label: 'Engine Room', deficiencies: 41, pct: 71 },
  { category: 'VC', label: 'Cargo Systems', deficiencies: 38, pct: 66 },
  { category: 'SW', label: 'Safety Mgmt', deficiencies: 33, pct: 57 },
  { category: 'BN', label: 'Bridge & Nav', deficiencies: 29, pct: 50 },
  { category: 'PC', label: 'Pollution Ctrl', deficiencies: 24, pct: 42 },
  { category: 'FF', label: 'Fire Fighting', deficiencies: 19, pct: 33 },
  { category: 'HS', label: 'Hull & Struct', deficiencies: 17, pct: 29 },
  { category: 'LS', label: 'Life Saving', deficiencies: 14, pct: 24 },
  { category: 'AC', label: 'Accommodation', deficiencies: 11, pct: 19 },
];

export const SEVERITY_DISTRIBUTION = [
  { name: 'Critical', value: 24, fill: 'hsl(355, 75%, 58%)' },
  { name: 'Severe', value: 58, fill: 'hsl(22, 90%, 55%)' },
  { name: 'Moderate', value: 87, fill: 'hsl(38, 92%, 50%)' },
  { name: 'Minor', value: 112, fill: 'hsl(210, 80%, 55%)' },
  { name: 'Normal', value: 341, fill: 'hsl(145, 60%, 40%)' },
];

export const VESSEL_BENCHMARK_DATA = [
  { vessel: 'CAPE ALBATROS', lsd: 71, owner: 'Cargill', scope: 'Anglo American' },
  { vessel: 'IRON EXPLORER', lsd: 62, owner: 'Pacific Bulk', scope: 'FMG' },
  { vessel: 'MINERAL YANG ZI', lsd: 55, owner: 'Minerals Shipping', scope: 'Anglo American' },
  { vessel: 'CAPE SHANGRILA', lsd: 47, owner: 'Pacific Bulk', scope: 'Anglo American' },
  { vessel: 'IRON MOUNTAIN', lsd: 44, owner: 'Star Bulk', scope: 'Anglo American' },
  { vessel: 'RIO GRANDE BULK', lsd: 38, owner: 'Rio Tinto Marine', scope: 'Rio Tinto' },
  { vessel: 'VALE VITORIA', lsd: 31, owner: 'Oldendorff', scope: 'Vale' },
  { vessel: 'MINERAL XIAMEN', lsd: 29, owner: 'COSCO Shipping', scope: 'Vale' },
];

export const VESSEL_TREND_COMPARISON = [
  { month: 'Jan 26', CAPE_SHANGRILA: 52, IRON_EXPLORER: 68, RIO_GRANDE: 41, VALE_VITORIA: 35 },
  { month: 'Feb 26', CAPE_SHANGRILA: 49, IRON_EXPLORER: 65, RIO_GRANDE: 39, VALE_VITORIA: 33 },
  { month: 'Mar 26', CAPE_SHANGRILA: 47, IRON_EXPLORER: 62, RIO_GRANDE: 38, VALE_VITORIA: 31 },
  { month: 'Apr 26', CAPE_SHANGRILA: 47, IRON_EXPLORER: 62, RIO_GRANDE: 38, VALE_VITORIA: 31 },
];

export const TOP_COMMON_FINDINGS = [
  { ref: 'MD.03', question: 'Brake linings within acceptable wear limits', vessels: 9, severity: 'Severe', lsd: 4 },
  { ref: 'MD.11', question: 'Safety pins present on all chain stoppers', vessels: 8, severity: 'Critical', lsd: 5 },
  { ref: 'ER.20', question: 'Pipework in satisfactory condition with no leaks', vessels: 8, severity: 'Moderate', lsd: 3 },
  { ref: 'VC.15', question: 'Hatch cover fittings (rubber seals, cleats, landing pads) satisfactory', vessels: 7, severity: 'Severe', lsd: 4 },
  { ref: 'SW.05', question: 'Permit to Work (PTW) system implemented effectively', vessels: 7, severity: 'Moderate', lsd: 3 },
  { ref: 'BN.11', question: 'Berth-to-berth passage planning implemented and documented', vessels: 6, severity: 'Moderate', lsd: 3 },
  { ref: 'ER.38', question: 'Electrical cables and connections in satisfactory condition', vessels: 6, severity: 'Severe', lsd: 4 },
  { ref: 'PC.06', question: 'OWS overboard valve secured', vessels: 5, severity: 'Critical', lsd: 5 },
  { ref: 'HS.01', question: 'Hull free from visible structural defects and significant corrosion', vessels: 5, severity: 'Severe', lsd: 4 },
  { ref: 'AC.02', question: 'Galley clean, properly equipped, and free from hazards', vessels: 4, severity: 'Normal', lsd: 1 },
];

export const OWNER_PERFORMANCE = [
  { owner: 'Cargill Ocean Transportation', inspections: 2, avgLsd: 71, detained: 1, criticalAvg: 7 },
  { owner: 'Pacific Bulk Carriers', inspections: 3, avgLsd: 55, detained: 0, criticalAvg: 3 },
  { owner: 'Minerals Shipping Co.', inspections: 1, avgLsd: 55, detained: 0, criticalAvg: 4 },
  { owner: 'Star Bulk Carriers', inspections: 1, avgLsd: 44, detained: 0, criticalAvg: 2 },
  { owner: 'Rio Tinto Marine', inspections: 1, avgLsd: 38, detained: 0, criticalAvg: 2 },
  { owner: 'Oldendorff Carriers', inspections: 2, avgLsd: 25, detained: 0, criticalAvg: 1 },
  { owner: 'COSCO Shipping', inspections: 1, avgLsd: 29, detained: 0, criticalAvg: 1 },
];